export default __webpack_public_path__ + "static/media/logo-vertical-color.f5f2183e.svg";